import type { Widget } from '../types/Widget';
import { WidgetType } from '../types/WidgetType';

const widgetConfigs: Widget[] = [
  {
    type: WidgetType.BUNDLE,
    label: 'Bundle',
    gaLabel: 'Bundle widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_MULTIMODEL,
    label: 'ANF Multimodel',
    gaLabel: 'ANF Multimodel widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_COLLECTION,
    label: 'ANF Collection',
    gaLabel: 'ANF Collection widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_BUTTON,
    label: 'ANF Button',
    gaLabel: 'ANF Button widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_DEAL,
    label: 'ANF Deal',
    gaLabel: 'ANF Deal widget',
    sites: [],
    group: 'default',
  },
  {
    type: WidgetType.ANF_TABLETOP,
    label: 'ANF Tabletop',
    gaLabel: 'ANF Tabletop widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.COMPARISON,
    label: 'Comparison Chart',
    gaLabel: 'CC',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.DEAL,
    label: 'Deal',
    gaLabel: 'Deal widget',
    sites: [],
    group: 'default',
  },
  {
    type: WidgetType.EDITORS_PICK,
    label: "Editor's Pick",
    gaLabel: "Editor's Pick widget",
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.TABS,
    label: 'Tabs',
    gaLabel: 'Tabs widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.INBODY,
    label: 'In Body',
    gaLabel: 'In Body widget',
    sites: ['all'],
    group: 'popular',
  },
  {
    type: WidgetType.LINK,
    label: 'Link',
    gaLabel: 'Link widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.MAGAZINE_SUBSCRIPTIONS,
    label: 'Magazine Subscriptions',
    gaLabel: 'Magazine Subscriptions Widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.MERCHANT_LINK,
    label: 'Merchant Link',
    gaLabel: 'Merchant Link widget',
    sites: ['all'],
    group: 'popular',
  },
  {
    type: WidgetType.MERCHANT_OVERVIEW,
    label: 'MerchantOverview',
    gaLabel: 'MerchantOverview widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.MOST_POPULAR_OFFERS,
    label: 'MostPopularOffers Widget',
    gaLabel: 'MostPopularOffers Widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.MULTI_MODEL_REVIEW,
    label: 'Multi-Model Review',
    gaLabel: 'Multi-Model Review widget',
    sites: ['all'],
    group: 'popular',
  },
  {
    type: WidgetType.PARTNER,
    label: 'Partner',
    gaLabel: 'Partner widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.PEACOCK,
    label: 'Peacock',
    gaLabel: 'Peacock widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.POCKET,
    label: 'Pocket',
    gaLabel: 'Pocket widget',
    sites: [],
    group: 'default',
  },
  {
    type: WidgetType.PRICE,
    label: 'Price',
    gaLabel: 'Price widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.PRODUCT_BLOCK,
    label: 'ProductBlock',
    gaLabel: 'ProductBlock widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.PRODUCT_FINDER_SEARCH,
    label: 'Product Finder Search',
    gaLabel: 'Product Finder Search widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.PRODUCT_NAME,
    label: 'Product Name',
    gaLabel: 'Product Name widget',
    sites: ['all'],
    group: 'popular',
  },
  {
    type: WidgetType.PROMOTION,
    label: 'Promotion',
    gaLabel: 'Promotion widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.REVIEW,
    label: 'Review',
    gaLabel: 'Review widget',
    sites: ['all'],
    group: 'popular',
  },
  {
    type: WidgetType.SCROLLABLE_TILE,
    label: 'Scrollable Tile',
    gaLabel: 'Scrollable Tile widget',
    sites: [],
    group: 'default',
  },
  {
    type: WidgetType.SEASONAL,
    label: 'Seasonal',
    gaLabel: 'Seasonal widget',
    sites: [],
    group: 'default',
  },
  {
    type: WidgetType.SIMPLE,
    label: 'Simple',
    gaLabel: 'Simple widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.SPECS,
    label: 'Specs',
    gaLabel: 'Specs widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.STICKY,
    label: 'Sticky',
    gaLabel: 'Sticky widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.STREAMING,
    label: 'Streaming',
    gaLabel: 'Streaming widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.TILE,
    label: 'Tile Widget',
    gaLabel: 'Tile Widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.USER_REVIEWS,
    label: 'UserReviews',
    gaLabel: 'UserReviews widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.USER_REWARDS,
    label: 'UserRewards',
    gaLabel: 'UserRewards widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.REWARD_SUMMARY,
    label: 'RewardSummary',
    gaLabel: 'RewardSummary widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.BROADBAND,
    label: 'Broadband',
    gaLabel: 'Broadband widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.TABLETOP,
    label: 'Tabletop',
    gaLabel: 'Tabletop widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.EAGLE,
    label: 'Eagle',
    gaLabel: 'Eagle widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.REWARD_NOTIFICATIONS,
    label: 'RewardNotifications',
    gaLabel: 'RewardNotifications widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_REVIEW,
    label: 'ANF Review',
    gaLabel: 'ANF Review widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.ANF_FEATURED_PRODUCT_BLOCK,
    label: 'ANF Featured product block',
    gaLabel: 'ANF Featured product block',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.PPC,
    label: 'PPC',
    gaLabel: 'PPC widget',
    sites: ['all'],
    group: 'default',
  },
  {
    type: WidgetType.COLLECTION,
    label: 'Collection',
    gaLabel: 'Collection widget',
    sites: ['all'],
    group: 'default',
  },
];
export default widgetConfigs;
